import type { ReactNode } from "react";

import { buttonClasses } from "@/components/ui/button";
import { SolidNav } from "@/lib/solid-nav";

export const primaryBtnClass = buttonClasses({
  variant: "teal",
  className: "w-full sm:w-auto",
});
export const secondaryBtnClass = buttonClasses({
  variant: "white",
  className:
    "w-full border border-teal-08 text-teal-08 hover:bg-teal-08 hover:text-white sm:w-auto",
});

// Shared branded layout for the 404 / error pages.
export function ErrorView({
  eyebrow,
  title,
  message,
  children,
  links,
}: {
  eyebrow: string;
  title: string;
  message: string;
  children: ReactNode;
  links?: ReactNode;
}) {
  return (
    <section className="bg-teal-01">
      <SolidNav />
      <div className="mx-auto flex min-h-[60vh] w-full max-w-160 flex-col items-center justify-center px-5 py-20 text-center md:px-10 lg:py-28">
        <p className="text-teal-08 text-sm font-bold tracking-[0.08em] uppercase">{eyebrow}</p>
        <h1 className="text-section text-teal-08 mt-4 text-balance">{title}</h1>
        <p className="text-grey-07 mt-4 max-w-120 text-base leading-relaxed tracking-[-0.01em] text-pretty">
          {message}
        </p>
        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          {children}
        </div>
        {links && (
          <div className="text-teal-08 mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold">
            {links}
          </div>
        )}
      </div>
    </section>
  );
}
